export const mockDropdownOptions = {
    projectPhase: ['Feasibility', 'Design', 'Construction', 'Commissioning', 'Operation', 'Decommissioning'],
    activities: ['Planning', 'Execution', 'Monitoring', 'Closing'],
    technicalDisciplines: ['Civil', 'Mechanical', 'Electrical', 'Instrumentation', 'Piping', 'HAC'],
    sector: ['Energy', 'Infrastructure', 'Healthcare & Life Science', 'Technology'],
    subSector: ['Oil & Gas', 'Renewables', 'Life Sciences', 'Transportation', 'Water'],
    keySkills: ['Construction Site Supervision', 'On-site Safety Management', 'Team Leadership & Coordination', 'Project Planning', 'Quality Assurance'],
  };